import {
  DXG,
  DataGrid,
} from '@lmt/unicorn-shared/app/common/devexpress/Grid/dx-grid';
import React, { FC } from 'react';
import ImportIcon from '@lmt/unicorn-shared/app/icons/tables/import.svg?react';
import ExportIcon from '@lmt/unicorn-shared/app/icons/tables/export.svg?react';
import SaveIcon from '@lmt/unicorn-shared/app/icons/tables/save.svg?react';
import AddIcon from '@lmt/unicorn-shared/app/icons/tables/add.svg?react';
import UndoIcon from '@lmt/unicorn-shared/app/icons/tables/undo.svg?react';
import { IconButton } from '../ui-kit/IconButton';
import { useDataGridExportHandler } from '@lmt/unicorn-shared/app/helpers/devextreme-helper';
import styles from './DataGridToolbar.module.scss';
import { useEventCallback } from '@mui/material';

interface GridToolbarProps {
  dataGridRef: React.RefObject<DataGrid | null>;
  isDirty: boolean;
  isSingleNewRow?: boolean;
  // import
  isImport?: boolean;
  inputFileRef?: React.RefObject<HTMLInputElement | null>;
  // export
  isExport?: boolean;
  exportFileName?: string;
}

export const DataGridToolbar: FC<GridToolbarProps> = (props) => {
  const {
    dataGridRef,
    inputFileRef,
    isImport,
    isExport,
    exportFileName,
    isDirty,
    isSingleNewRow,
  } = props;

  const onSave = useEventCallback(() =>
    dataGridRef.current?.instance().saveEditData(),
  );
  const onUndo = useEventCallback(() =>
    dataGridRef.current?.instance().cancelEditData(),
  );

  const onAdd = useEventCallback(() => {
    const gridInstance = dataGridRef.current?.instance();
    if (!gridInstance) {
      return;
    }
    if (isSingleNewRow) {
      const element = gridInstance.element();
      const isNewRowExist = element?.innerHTML.includes('dx-row-inserted');

      if (isNewRowExist) {
        return;
      }
    }

    gridInstance.addRow();
  });

  const onExportHandler = useDataGridExportHandler({
    fileName: exportFileName ?? 'Data',
  });
  const onExport = useEventCallback(() => {
    const gridInstance = dataGridRef.current?.instance();
    if (gridInstance) {
      onExportHandler({
        component: gridInstance,
        cancel: false,
      } as any);
    }
  });

  return (
    <DXG.Toolbar>
      <DXG.Item location="after">
        <IconButton
          color="blue"
          testId={'add-toolbar-button'}
          iconComponent={<AddIcon />}
          onClick={onAdd}
          className={styles.iconButton}
        />
      </DXG.Item>
      <DXG.Item location="after">
        <IconButton
          color="blue"
          testId={'save-toolbar-button'}
          iconComponent={<SaveIcon />}
          disabled={!isDirty}
          onClick={onSave}
          className={styles.iconButton}
        />
      </DXG.Item>
      <DXG.Item location="after">
        <IconButton
          color="blue"
          testId={'undo-toolbar-button'}
          iconComponent={<UndoIcon />}
          disabled={!isDirty}
          onClick={onUndo}
          className={styles.iconButton}
        />
      </DXG.Item>
      {isExport && (
        <DXG.Item location="after">
          <IconButton
            color="blue"
            testId={'export-toolbar-button'}
            iconComponent={<ExportIcon />}
            onClick={onExport}
            className={styles.iconButton}
          />
        </DXG.Item>
      )}
      {isImport && (
        <DXG.Item location="after">
          <IconButton
            color="blue"
            testId={'import-toolbar-button'}
            iconComponent={<ImportIcon />}
            onClick={() => inputFileRef?.current?.click()}
            className={styles.iconButton}
          />
        </DXG.Item>
      )}
    </DXG.Toolbar>
  );
};
